module.exports = __webpack_public_path__ + "static/sir-salon-solution-d405184b3764257b33c6e94c9ae02568.png";